/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeDefinitionDTO } from './AttributeDefinitionDTO';
import {
    AttributeDefinitionDTOFromJSON,
    AttributeDefinitionDTOFromJSONTyped,
    AttributeDefinitionDTOToJSON,
} from './AttributeDefinitionDTO';
import type { NextPageDTO } from './NextPageDTO';
import {
    NextPageDTOFromJSON,
    NextPageDTOFromJSONTyped,
    NextPageDTOToJSON,
} from './NextPageDTO';

/**
 * 
 * @export
 * @interface QueryAttributeDefinitionsResultDTO
 */
export interface QueryAttributeDefinitionsResultDTO {
    /**
     * 
     * @type {Array<AttributeDefinitionDTO>}
     * @memberof QueryAttributeDefinitionsResultDTO
     */
    entries: Array<AttributeDefinitionDTO>;
    /**
     * 
     * @type {NextPageDTO}
     * @memberof QueryAttributeDefinitionsResultDTO
     */
    nextPage: NextPageDTO;
}

/**
 * Check if a given object implements the QueryAttributeDefinitionsResultDTO interface.
 */
export function instanceOfQueryAttributeDefinitionsResultDTO(value: object): value is QueryAttributeDefinitionsResultDTO {
    if (!('entries' in value) || value['entries'] === undefined) return false;
    if (!('nextPage' in value) || value['nextPage'] === undefined) return false;
    return true;
}

export function QueryAttributeDefinitionsResultDTOFromJSON(json: any): QueryAttributeDefinitionsResultDTO {
    return QueryAttributeDefinitionsResultDTOFromJSONTyped(json, false);
}

export function QueryAttributeDefinitionsResultDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryAttributeDefinitionsResultDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'entries': ((json['entries'] as Array<any>).map(AttributeDefinitionDTOFromJSON)),
        'nextPage': NextPageDTOFromJSON(json['nextPage']),
    };
}

export function QueryAttributeDefinitionsResultDTOToJSON(value?: QueryAttributeDefinitionsResultDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'entries': ((value['entries'] as Array<any>).map(AttributeDefinitionDTOToJSON)),
        'nextPage': NextPageDTOToJSON(value['nextPage']),
    };
}

